<template>
    <!-- 场地管理－新增编辑详情页 -->
    <content-view>
        <div slot="header">
            <a-steps :current="current" size="small" v-if="isEdit !== 'detailBranchStore'">
                <a-step title="场地信息" />
                <a-step title="主管信息" />
                <a-step title="场地图文介绍" />
                <a-step title="确认新增" />
            </a-steps>
        </div>
        <div class="steps-in">
            <a-card title="场地信息" :bordered="false" v-show="current == 0 || current == 3">
                <a-button v-if="current == 3 && isEdit !== 'detailBranchStore' && stepOneDisable" type="primary" slot="extra" @click="stepOneDisable = false;current = 0">重新编辑</a-button>
                <!-- <a-button v-if="current == 3 && !stepOneDisable" slot="extra" @click="backPageList">取消</a-button> -->
                <!-- <a-button v-if="current == 3 && !stepOneDisable" type="primary" slot="extra" @click="stepOneDisable = true">保存</a-button> -->
                <step-one :allData="allData" :showOneBtn="showStepOneBtn" :oneDisable="stepOneDisable" ref="stepOneData" @stepOneData="getStepOne"></step-one>
            </a-card>
            <a-card title="主管信息" :bordered="false" v-show="current == 1 || current == 3">
                <a-button v-if="current == 3 && isEdit !== 'detailBranchStore' && stepTwoDisable" type="primary" slot="extra" @click="stepTwoDisable = false;current = 1">重新编辑</a-button>
                <!-- <a-button v-if="current == 3 && !stepTwoDisable" slot="extra" @click="backPageList">取消</a-button> -->
                <!-- <a-button v-if="current == 3 && !stepTwoDisable" type="primary" slot="extra" @click="stepTwoDisable = true">保存</a-button> -->
                <step-two :allData="allData" :showStepTwoBtn="showStepTwoBtn" :stepTwoDisable="stepTwoDisable" ref="stepTwoData" @stepTwoData="getStepTwo"></step-two>
            </a-card>
            <a-card title="场地图文介绍" :bordered="false" v-show="current == 2 || current == 3">
                <a-button v-if="current == 3 && isEdit !== 'detailBranchStore' && stepThreeDisable" type="primary" slot="extra" @click="stepThreeDisable = false;current = 2">重新编辑</a-button>
                <!-- <a-button v-if="current == 3 && !stepThreeDisable" slot="extra" @click="backPageList">取消</a-button> -->
                <!-- <a-button v-if="current == 3 && !stepThreeDisable" type="primary" slot="extra" @click="stepThreeDisable = true">保存</a-button> -->
                <step-three :allData="allData" :current.sync="current" :showStepThreeBtn="showStepThreeBtn" :stepThreeDisable="stepThreeDisable" ref="stepThreeData" @stepThreeData="getStepThree"></step-three>
            </a-card>
            <a-card class="text-right" v-if="current == 3">
                <a-button v-if="isEdit === 'detailBranchStore'" @click="$router.go(-1)">返回</a-button>
                <a-button v-else @click="backPage">上一步</a-button>
                <a-button v-if="isEdit === 'addBranchStore'" type="primary" html-type="submit" @click="submitAll" :loading="S_loading_submit" >确认新增</a-button>
                <a-button v-if="isEdit === 'updateBranchStore'" type="primary" html-type="submit" @click="submitAllUpdate" :loading="S_loading_submit" >保存</a-button>
            </a-card>
        </div>
    </content-view>
</template>

<script type="text/javascript">
import StepOne from '@/components/modules/platform/branchStore.component.one'
import StepTwo from '@/components/modules/platform/branchStore.component.two'
import StepThree from '@/components/modules/platform/branchStore.component.three'
export default {
    name: "ticket",
    components: {
        StepOne,
        StepTwo,
        StepThree,
    },
    props: {},
    data() {
        return {
            S_loading_submit: false,
            // 每步的启用禁用
            stepOneDisable: false,
            stepTwoDisable: false,
            stepThreeDisable: false,
            // 每步按钮的显示隐藏
            showStepOneBtn: true,
            showStepTwoBtn: true,
            showStepThreeBtn: true,
            current: 0,
            id: '',
            isEdit: '',
            allData: {},
            oneData: {},
            twoData: {},
            threeData: {},

        };
    },
    computed: {},
    methods: {
        getDetail() {
            this.$api.totalPlatform.shopDetail({
                params: {id: this.id}
            })
            .then(res => {
                this.allData = Object.assign({},res)
                this.current = this.isEdit === 'detailBranchStore' ? 3 : 0
            })
        },
        // 第一步 接收第一步子组件的数据
        getStepOne(val) {
            this.current = val.current;
            this.oneData = Object.assign({},val);
            this.oneData.workTime = JSON.stringify(this.oneData.workTime);
        },
        // 第二步 接收第二步子组件的数据
        getStepTwo(val) {
            this.current = val.current;
            this.twoData = Object.assign({},val);
        },
        // 第三步 接收第三步子组件的数据
        getStepThree(val) {
            this.current = val.current;
            this.threeData = Object.assign({},val);
        },
        // 第四步 新增时提交全部数据
        submitAll() {
            this.S_loading_submit = true;
            this.$api.totalPlatform.shopInfo({
                body: Object.assign(this.oneData,this.twoData,this.threeData)
            })
            .then(res => {
                this.S_loading_submit = false
                this.$message.success('操作成功', 2);
                this.$router.push({ name: "sitePages"});
            }).catch(err => {
                this.S_loading_submit = false;
            })
        },
        // 第四步 编辑时提交全部数据
        submitAllUpdate() {
            this.$api.totalPlatform.shopInfoUpdate({
                body: Object.assign(this.oneData,this.twoData,this.threeData,{id:this.id})
            })
            .then(res => {
                this.$message.success('操作成功', 2);
                this.$router.push({ name: "sitePages"});
            })
        },
        backPageList() {
            this.$router.push({ name: "sitePages" });
        },
        backPage() {
            this.current = 2
            this.showStepThreeBtn = true
        }
    },
    created() {},
    mounted() {
        this.isEdit = this.$route.name
        if( this.isEdit === 'updateBranchStore') {
            // 编辑
            this.id = this.$route.query.id
            this.getDetail()
        }else if( this.isEdit === 'detailBranchStore') {
            // 详情
            this.stepOneDisable = true
            this.stepTwoDisable = true
            this.stepThreeDisable = true
            this.id = this.$route.query.id
            this.getDetail()
        }
    },
    watch: {
        'current'(newValue) {
            this.showStepOneBtn = newValue == 3 ? false : true
            this.showStepTwoBtn = newValue == 3 ? false : true
            this.showStepThreeBtn = newValue == 3 ? false : true

            this.stepOneDisable = newValue == 3 || this.isEdit === 'detailBranchStore' ? true : false;
            this.stepTwoDisable = newValue == 3 || this.isEdit == 'detailBranchStore' ? true : false;
            this.stepThreeDisable = newValue == 3 || this.isEdit === 'detailBranchStore' ? true : false;
        },
    }
};
</script>
<style lang="scss">
    .steps-in {
        .ant-card {
            margin-bottom: 24px;
        }
    }
</style>